import { Box, Skeleton } from '@mui/material';
import { ContentSt, FooterSt } from './page-footer.styled';

export const FooterSkeleton = () =>
<FooterSt id="footer-skeleton__components-page-footer__footerst__l5">
    <ContentSt id="footer-skeleton__components-page-footer__contentst__l6">
      <Skeleton id="footer-skeleton__components-page-footer__skeleton__l7" variant="rounded" width={80} height={24} sx={{ borderRadius: 1 }} />
      <Box id="footer-skeleton__components-page-footer__box__l8" flex={1} />
      <Skeleton id="footer-skeleton__components-page-footer__skeleton__l9" variant="text" width={160} />
    </ContentSt>
  </FooterSt>;